import { Box, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { AppDialog } from "AttendanceForm/Components/Dialog/Dialog";
import { useTranslation } from "react-i18next";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { FormatDateString } from "AttendanceForm/Utils/Dates/dates";
import { useLocation } from "react-router-dom";
import { LocationState } from "AttendanceForm/Types/types";
import { PageNotFound } from "../Errors/PageNotFound";

export const SubmissionSuccess = (): React.ReactElement => {
  const { t } = useTranslation("learnerDetailsForm");
  const { t: tcommon } = useTranslation("common");
  const styles = useStyles();
  const location = useLocation();
  const eventName = (location.state as LocationState)?.eventName;
  const eventDate = (location.state as LocationState)?.eventDate;

  return (
    <>
      {eventDate ? (
        <AppDialog
          id="submissionSuccessModal"
          maxWidth="md"
          open
          title={t("successSubmissionPopupTitle")}
          onCloseHandler={() => {}}
          popupIcon={<CheckCircleIcon className={styles.icon} />}
          hasCloseButton={false}
        >
          <Typography gutterBottom>{t("successfulSubmission")}</Typography>
          <Box paddingTop={2} paddingBottom={2}>
            <Typography id="event-name-id" gutterBottom>
              <strong>{tcommon("eventName")}</strong> {eventName ? `'${eventName}'` : ""}
            </Typography>
            <Typography id="event-date-id" gutterBottom>
              <strong>{tcommon("eventDate")}</strong> {FormatDateString(eventDate)}{" "}
            </Typography>
          </Box>
          <Typography>{t("successfulPopupHelper")}</Typography>
        </AppDialog>
      ) : (
        <PageNotFound />
      )}
    </>
  );
};

const useStyles = makeStyles(() => ({
  icon: {
    color: "#5CB85C",
  },
}));
